import Image, { StaticImageData } from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';
import { CropAction, CropStage, CurrentAction } from '@/models/cropGuide';
import { isArray } from '@/utils/helper';
import Caption from '../Caption';
import CaretDownIcon from '../icons/CaretDownIcon';
import SubHeading, { VARIANT } from '../SubHeading';
import CropActionCard from './CropActionCard';
interface Props {
  cropStage: CropStage;
  index: number;
  image: StaticImageData;
  cropActions: CropAction[];
  onClick: VoidFunction;
  cropId: number;
  sowingDate: string | null;
  currentAction: CurrentAction;
  fromApp: boolean;
}
const CropStageAccordian = ({
  cropStage,
  index,
  image,
  cropActions,
  cropId,
  onClick,
  sowingDate,
  currentAction,
  fromApp
}: Props) => {
  const {
    t
  } = useTranslation('cropGuide');
  const [isOpen, setIsOpen] = useState(false);
  const [isCurrentStage, setIsCurrentStage] = useState(false);
  useEffect(() => {
    const isStage = cropActions.some(({
      id,
      action_type
    }) => id === currentAction.id && action_type === currentAction.action);
    setIsCurrentStage(isStage);
    if (isStage) {
      setIsOpen(true);
    }
  }, [currentAction, cropActions]);
  return cropStage && cropActions.length > 0 ? <>
      <div onClick={() => setIsOpen(prev => !prev)}>
        <div className={`flex px-2 py-3 items-center cursor-pointer sticky ${fromApp ? 'top-0' : 'top-16'} ${isOpen ? 'z-20' : ''} ${isCurrentStage ? 'bg-primary-80' : 'bg-white'}`}>
          <div className="h-12 m-auto relative w-12 shrink-0">
            <Image alt={cropStage.stage} src={image} width={48} height={48} data-sentry-element="Image" data-sentry-source-file="CropStageAccordian.tsx" />
          </div>
          <div className="mx-3 grow">
            <SubHeading variant={VARIANT.BIG} className={`md:text-xl ${isCurrentStage ? 'text-white' : 'text-primary-100'}`} data-sentry-element="SubHeading" data-sentry-source-file="CropStageAccordian.tsx">
              {cropStage.stage}
            </SubHeading>
            <Caption className={`md:text-xs ${isCurrentStage ? 'text-white' : 'text-neutral-90'}`} label={isCurrentStage ? t('currently_going') : `${t('stage')} ${index}`} data-sentry-element="Caption" data-sentry-source-file="CropStageAccordian.tsx" />
          </div>
          <div>
            <CaretDownIcon className={`fill-transparent ${isCurrentStage ? 'stroke-white' : 'stroke-primary-100'} stroke-2 w-8 duration-300 ease-in-out h-4 transition-all shrink-0 ${isOpen ? '-rotate-180' : 'rotate-0'}`} data-sentry-element="CaretDownIcon" data-sentry-source-file="CropStageAccordian.tsx" />
          </div>
        </div>

        {isArray(cropActions) && isOpen && <div className="bg-neutral-10 pt-2">
            {cropActions.map((action, index) => <CropActionCard key={`${index}-${action.id}`} cropAction={action} onClick={onClick} isCurrent={action.id === currentAction.id && action.action_type === currentAction.action} cropId={cropId} sowingDate={sowingDate} />)}
          </div>}
      </div>
    </> : null;
};
export default CropStageAccordian;